import React, { Component } from "react";
import { Icon } from "@material-ui/core";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import classNames from "classnames";
import ColorChit from "./ColorChit";

const AccentColor = ({
    id,
    index,
    color,
    trackPicker,
    removeColor,
    updateColor,
    disabled,
    removable
}) => {
    return (
        <Draggable draggableId={id} index={index + 1} isDragDisabled={disabled}>
            {provided => {
                return (
                    <div
                        ref={provided.innerRef}
                        key={id}
                        className={classNames("colorItem")}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <ColorChit
                            color={color}
                            name={id}
                            trackPicker={trackPicker}
                            remove={removable ? removeColor : null}
                            update={updateColor}
                        />
                    </div>
                );
            }}
        </Draggable>
    );
};

class SelectedColors extends Component {
    constructor() {
        super();
        this.state = {
            checked: false,
            currentPicker: null,
            accentCount: 0,
            dragging: false
        };
    }

    trackPicker = pickerName => {
        this.setState({ currentPicker: pickerName });
    };

    renderAccents = colors => {
        const { classes, addColor } = this.props;
        let colorList = Object.keys(colors).filter(item =>
            item.includes("accent")
        );
        colorList.sort();

        return (
            <div className={classes.inlineFlex}>
                <Droppable
                    droppableId="droppableAccents1"
                    direction="horizontal"
                >
                    {provided => (
                        <div
                            className={classNames(classes.inlineFlex)}
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {colorList.map((key, index) => {
                                if (index < 6) {
                                    return (
                                        <AccentColor
                                            index={index}
                                            key={key}
                                            id={key}
                                            color={colors[key]}
                                            trackPicker={this.trackPicker}
                                            removeColor={this.props.removeColor}
                                            updateColor={this.props.updateColor}
                                            removable={colorList.length > 1}
                                            disabled={
                                                this.state.currentPicker === key
                                            }
                                        />
                                    );
                                }
                            })}
                            {colorList.length < 6 && (
                                <div
                                    className={classNames(classes.addNew, {
                                        hidden: this.state.dragging
                                    })}
                                    onClick={() => addColor()}
                                >
                                    <Icon color="primary">add</Icon>
                                </div>
                            )}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>

                {colorList.length > 5 && (
                    <div className={classes.inlineFlex}>
                        <Droppable
                            droppableId="droppableAccents2"
                            direction="horizontal"
                        >
                            {provided => (
                                <div
                                    className={classNames(classes.inlineFlex)}
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    {colorList.map((key, index) => {
                                        if (index > 5) {
                                            return (
                                                <AccentColor
                                                    index={index}
                                                    key={key}
                                                    id={key}
                                                    color={colors[key]}
                                                    trackPicker={
                                                        this.trackPicker
                                                    }
                                                    removeColor={
                                                        this.props.removeColor
                                                    }
                                                    removable={true}
                                                    updateColor={
                                                        this.props.updateColor
                                                    }
                                                    disabled={
                                                        this.state
                                                            .currentPicker ===
                                                        key
                                                    }
                                                />
                                            );
                                        }
                                    })}
                                    {(colorList.length > 5 && colorList.length < 10) &&
                                        <div
                                            className={classNames(
                                                classes.addNew,
                                                {
                                                    firstChild:
                                                        colorList.length ===
                                                        6,
                                                    hidden:
                                                        this.state
                                                            .dragging &&
                                                        colorList.length !==
                                                        6
                                                }
                                            )}
                                            onClick={() => addColor()}
                                        >
                                            <Icon color="primary">add</Icon>
                                        </div>
                                    }
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </div>
                )}
            </div>
        );
    };
    onDragEnd = result => {
        let colors = Object.assign({}, this.props.theme.colors);
        this.setState({ dragging: false });

        if (!result.destination) {
            return;
        }

        let colorList = Object.keys(this.props.theme.colors).filter(item =>
            item.includes("accent")
        );
        colorList.unshift("theme");

        //adjusting the in index based on the order
        if (result.destination.droppableId === "droppableAccents2" &&
            result.destination.droppableId !== result.source.droppableId) {
            result.destination.index += 6;
        }

        if (result.destination.droppableId === "droppableAccents1") {
            result.destination.index += 1;
        }

        colorList.splice(
            result.destination.index,
            0,
            colorList.splice(result.source.index, 1)[0]
        );
        let updatedColorList = {};
        colorList.map((item, index) => {
            if (index === 0) {
                updatedColorList.theme = colors[item];
            } else {
                updatedColorList["accent" + index] = colors[item];
            }
            delete colors[item]; // for old presentations with wrong color names
        });
        colors = { ...colors, ...updatedColorList };
        this.props.updateColor(colors);
    };
    onDragStart = () => {
        this.setState({ dragging: true });
    };

    render() {
        let { classes, theme } = this.props;
        return (
            <DragDropContext
                onDragEnd={this.onDragEnd}
                onDragStart={this.onDragStart}
            >
                <Droppable droppableId="droppableTheme" direction="horizontal">
                    {provided => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            style={{ position: "relative", float: "left" }}
                        >
                            <Draggable
                                key={0}
                                draggableId="theme"
                                index={0}
                                isDragDisabled={
                                    this.state.currentPicker === "theme"
                                }
                            >
                                {provided => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className={classes.inlineFlex}
                                    >
                                        <ColorChit
                                            color={theme.colors.theme}
                                            name="theme"
                                            style={{ display: "flex" }}
                                            trackPicker={this.trackPicker}
                                            update={this.props.updateColor}
                                        />
                                    </div>
                                )}
                            </Draggable>
                            {provided.placeholder}
                            <div style={{ clear: "both" }} />
                            <div
                                className={classNames(
                                    classes.label,
                                    classes.themeLabel
                                )}
                            >
                                Theme
                            </div>
                        </div>
                    )}
                </Droppable>
                <div className={classes.inlineFlex} style={{ width: 280 }}>
                    {this.renderAccents(this.props.colors)}

                    <div style={{ clear: "both", width: "100%" }} />
                    <div
                        className={classes.label}
                        style={{ textAlign: "left", paddingLeft: 10 }}
                    >
                        Accent Colors
                    </div>
                </div>
            </DragDropContext>
        );
    }
}

export default SelectedColors;
